import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { uploadNotfis } from '../../../services/naturaOpsServices'
import ResultPanel from './components/ResultPanel'

const T = 'natura_operations.notfis_upload'

export default function NotfisUploadPage() {
  const { t } = useTranslation()
  const [file, setFile] = useState(null)
  const [status, setStatus] = useState('idle') // idle | uploading | done | error
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  const handleSubmit = async () => {
    if (!file) return
    setStatus('uploading')
    setError(null)
    setResult(null)
    try {
      const data = await uploadNotfis(file)
      setResult(data)
      setStatus('done')
    } catch (e) {
      const payload = e?.response?.data
      // The endpoint answers with an error code; fall back to the raw message
      // so an unmapped failure still says something the operator can report.
      setError(payload?.error ? t(`${T}.error_${payload.error}`, payload) : e.message)
      setStatus('error')
    }
  }

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">{t(`${T}.title`)}</h1>

      <section className="bg-gray-50 border border-gray-200 rounded p-4 mb-6">
        <h2 className="font-semibold mb-2">📋 {t(`${T}.instructions_heading`)}</h2>
        <ol className="list-decimal pl-6 text-sm space-y-1">
          <li>{t(`${T}.instructions_step1`)}</li>
          <li>{t(`${T}.instructions_step2`)}</li>
          <li>{t(`${T}.instructions_step3`)}</li>
          <li>{t(`${T}.instructions_step4`)}</li>
        </ol>
      </section>

      <div className="mb-4">
        <label htmlFor="notfis-file" className="block border-2 border-dashed border-gray-300 rounded p-6 text-center cursor-pointer hover:border-gray-400">
          <input
            id="notfis-file"
            type="file"
            aria-label="file"
            className="hidden"
            onChange={e => {
              const selected = e.target.files?.[0]
              if (!selected) return
              setFile(selected)
              setStatus('idle')
              setResult(null)
              setError(null)
            }}
          />
          <span className="text-sm text-gray-600">{file ? file.name : t(`${T}.file_picker_hint`)}</span>
        </label>
      </div>

      <button
        onClick={handleSubmit}
        disabled={!file || status === 'uploading'}
        className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-white"
      >
        {status === 'uploading' ? t(`${T}.submit_loading`) : t(`${T}.submit`)}
      </button>

      {status === 'done' && <ResultPanel result={result} />}
      {status === 'error' && <div className="mt-6 p-4 border border-red-200 bg-red-50 rounded text-sm text-red-800">{error}</div>}
    </div>
  )
}
